/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Label_Boat_KindInputs */

const es_ab_label_boat_kind = /** @type {(inputs: Ab_Label_Boat_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de barco`)
};

const gl_ab_label_boat_kind = /** @type {(inputs: Ab_Label_Boat_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de barco`)
};

const en_ab_label_boat_kind = /** @type {(inputs: Ab_Label_Boat_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat type`)
};

/**
* | output |
* | --- |
* | "Boat type" |
*
* @param {Ab_Label_Boat_KindInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_label_boat_kind = /** @type {((inputs?: Ab_Label_Boat_KindInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Label_Boat_KindInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_label_boat_kind(inputs)
	if (locale === "en") return en_ab_label_boat_kind(inputs)
	return es_ab_label_boat_kind(inputs)
});